import List from 'devextreme/ui/list';
import Accordion from 'devextreme/ui/accordion';
import Tooltip from 'devextreme/ui/tooltip';
import { v4 as uuidv4 } from 'uuid';
/**
 * It creates a menu list and appends it to the list element.
 */
export class DinapsisNavbarSidebarMenu {
    constructor(menus, menuClick) {
        this.accordions = [];
        /**
         * Gets or sets the application logo
         */
        this.logo = '';
        /**
         * Declaring a public variable called menuValue and
         * initializing it to an empty array of MenuItem objects.
         */
        this.menuValue = new Array();
        /**
         *  Represents the value of the status of the menu
         */
        this.openedValue = false;
        /**
         * A variable that is used to store the id of the last selected menu item.
         */
        this.oldItemIdSelected = '';
        /**
         * A private variable that is used to set the size of Icon Parent element
         */
        this.iconParentElementSize = '24px';
        /**
         * A private variable that is used to set the size of Icon Subelement
         */
        this.iconSubElementSize = '18px';
        /**
         * A private list for set unique id for tooltips.
         */
        this.tooltipRandomId = [];
        this.menu = menus;
        this.menuClick = (e) => {
            this.selectedOptionMenu(e);
            menuClick(e);
        };
    }
    /**
     * Set the value
     * @param {Boolean} value - Boolean - The value to set the opened property to.
     */
    set opened(value) {
        this.openedValue = value;
    }
    /**
     * Gets the status of the side nav if is open or not
     */
    get opened() {
        return this.openedValue;
    }
    /**
     * Gets or sets the status of the side nav if is open or not
     * @returns The menuValue property.
     */
    get menu() {
        return this.menuValue;
    }
    /**
     * The function takes a string and returns a string.
     * @param value - The value of the input.
     */
    set menu(value) {
        this.menuValue = value;
    }
    /**
     * This function set the styles for the item which has the property selected on true
     * Also if there is more than one item with that property on true it only accept the first one
     * @param {MenuItem} item - element of menu
     * @param {HTMLDivElement} listelement - list of elements generated
     */
    setDefaultItemSelected(item, listelement) {
        if (!item.selected || this.oldItemIdSelected)
            return;
        this.oldItemIdSelected = item.id;
        const element = listelement.querySelector(`#${this.oldItemIdSelected}`);
        if (!element)
            return;
        if (element.className === 'selected-item')
            element.className = 'selected-item-active';
        if (element.className === 'selected-item-single-item')
            element.className = 'selected-item-single-item-active';
        const parentElement = element === null || element === void 0 ? void 0 : element.parentElement;
        const newElementMenuSelected = parentElement === null || parentElement === void 0 ? void 0 : parentElement.getElementsByClassName('item-container')[0];
        if (newElementMenuSelected) {
            if (newElementMenuSelected.className === 'item-container')
                newElementMenuSelected.className = 'item-container-selected';
        }
    }
    /**
     * The function loops through the menu array, and if the menu item has children, it creates a
     * submenu list and appends it to the accordion.
     * Otherwise it creates a menu list and appends it to
     * the list element.
     * @returns The return value is a div element with the class name "menu-list" and the id
     * "menu-list-X".
     */
    Render() {
        const listelement = document.createElement('div');
        listelement.id = 'containerMenu';
        this.menu.forEach((option) => {
            if (option.children.length > 0) {
                const childrenList = this.generateMenuList(option.children);
                if (childrenList) {
                    listelement.append(this.generateAccordion(option, childrenList));
                    option.children.forEach((child) => {
                        this.setDefaultItemSelected(child, listelement);
                    });
                }
                else {
                    // eslint-disable-next-line no-console
                    console.warn('Submenu list its not generated correctly');
                }
            }
            else {
                listelement.append(this.generateMenuList([option], true));
                this.setDefaultItemSelected(option, listelement);
            }
            if (option.hasSeparator && option.hasSeparator === true) {
                const separator = document.createElement('div');
                separator.className = 'item-separator';
                listelement.append(separator);
            }
        });
        return listelement;
    }
    /**
     * This function creates a new List object, set options elementAttr anditems.
     * Then returns the listMenu object.
     * @param menuList - Array - the list of menu items
     * @returns A div element with a list of menu items.
     */
    generateMenuList(menuList, singleItem = false) {
        const listMenu = document.createElement('div');
        const list = new List(listMenu);
        list.option('items', menuList);
        list.option('itemTemplate', (data, _index, element) => {
            var _a;
            const itemMenuContainer = document.createElement('div');
            const itemContainer = document.createElement('div');
            itemContainer.style.display = 'flex';
            const itemMenu = document.createElement('div');
            const selectedDiv = document.createElement('div');
            const iconElement = document.createElement('span');
            selectedDiv.id = data.id;
            iconElement.className = (_a = data.iconsFont) !== null && _a !== void 0 ? _a : 'material-icons-round';
            iconElement.innerText = data.icon;
            iconElement.style.fontSize = this.iconSubElementSize;
            iconElement.style.width = this.iconSubElementSize;
            iconElement.style.overflow = 'hidden';
            if (singleItem) {
                iconElement.style.fontSize = this.iconParentElementSize;
                iconElement.style.width = this.iconParentElementSize;
                itemMenuContainer.className = 'container-item-menu-single-item';
                selectedDiv.className = 'selected-item-single-item';
            }
            else {
                itemMenuContainer.className = 'container-item-menu';
                selectedDiv.className = 'selected-item';
            }
            const tooltipId = uuidv4();
            this.tooltipRandomId.push(tooltipId);
            itemMenu.innerHTML = `<div class="menu-item-text" id="tooltip-menu-item-${tooltipId}">${data.text}</div>`;
            itemMenu.className = 'menu-item';
            itemContainer.className = 'item-container';
            if (selectedDiv)
                itemMenuContainer.append(selectedDiv);
            if (iconElement)
                itemContainer.append(iconElement);
            if (itemMenu)
                itemContainer.append(itemMenu);
            itemContainer.append(itemMenu);
            itemMenuContainer.append(itemContainer);
            return element.append(itemMenuContainer);
        });
        list.on('itemClick', this.menuClick);
        const listClassDiv = document.createElement('div');
        listClassDiv.className = 'accordion-menu-item-list';
        listClassDiv.append(listMenu);
        return listClassDiv;
    }
    /**
     * It creates a new accordion menu, sets the options, and returns the accordion menu.
     * @param {MenuItem} menuOption - the parent menu item
     * @param {any} childrenList - an array of HTML elements that will be displayed in the accordion
     * @returns A div element with the accordion widget initialized.
     */
    generateAccordion(menuOption, childrenList) {
        const accordionMenu = document.createElement('div');
        const options = {
            collapsible: true,
            multiple: true,
            animationDuration: 100,
            itemTitleTemplate: () => {
                var _a;
                const itemMenuContainer = document.createElement('div');
                const text = document.createElement('span');
                const iconElement = document.createElement('span');
                itemMenuContainer.style.display = 'flex';
                const tooltipId = uuidv4();
                this.tooltipRandomId.push(tooltipId);
                text.innerHTML = `<div class="menu-item-text" id="tooltip-menu-item-${tooltipId}">${menuOption.text}</div>`;
                text.className = 'menu-item';
                iconElement.className = (_a = menuOption.iconsFont) !== null && _a !== void 0 ? _a : 'material-icons-round';
                iconElement.innerText = menuOption.icon;
                iconElement.style.fontSize = this.iconParentElementSize;
                iconElement.style.width = this.iconParentElementSize;
                iconElement.style.overflow = 'hidden';
                iconElement.style.minHeight = '24px';
                if (iconElement)
                    itemMenuContainer.append(iconElement);
                itemMenuContainer.append(text);
                return itemMenuContainer;
            },
            items: [{
                    template: () => childrenList,
                }],
        };
        // eslint-disable-next-line no-new
        const accordion = new Accordion(accordionMenu, options);
        this.accordions.push(accordion);
        // create another div to apply de classname
        const accordionMenuClass = document.createElement('div');
        accordionMenuClass.className = 'accordion-menu-item-list';
        accordionMenuClass.append(accordionMenu);
        return accordionMenuClass;
    }
    /**
     * It's a function that is called when a user clicks on a menu item.
     * The function change the background color of the menu item that was clicked on.
     * @param {any} e - any - the event object
     */
    selectedOptionMenu(e) {
        const itemId = e.itemData.id;
        if (itemId) {
            const oldElement = document.getElementById(this.oldItemIdSelected);
            const oldElementParent = oldElement === null || oldElement === void 0 ? void 0 : oldElement.parentElement;
            const oldElementMenuSelected = oldElementParent === null || oldElementParent === void 0 ? void 0 : oldElementParent.getElementsByClassName('item-container-selected')[0];
            if (oldElementMenuSelected) {
                if (oldElementMenuSelected.className === 'item-container-selected')
                    oldElementMenuSelected.className = 'item-container';
            }
            if (oldElement) {
                if (oldElement.className === 'selected-item-active')
                    oldElement.className = 'selected-item';
                if (oldElement.className === 'selected-item-single-item-active')
                    oldElement.className = 'selected-item-single-item';
            }
            this.oldItemIdSelected = itemId;
            const newElement = document.getElementById(e.itemData.id);
            const newElementParent = newElement === null || newElement === void 0 ? void 0 : newElement.parentElement;
            const newElementMenuSelected = newElementParent === null || newElementParent === void 0 ? void 0 : newElementParent.getElementsByClassName('item-container')[0];
            if (newElementMenuSelected) {
                if (newElementMenuSelected.className === 'item-container')
                    newElementMenuSelected.className = 'item-container-selected';
            }
            if (newElement) {
                if (newElement.className === 'selected-item')
                    newElement.className = 'selected-item-active';
                if (newElement.className === 'selected-item-single-item')
                    newElement.className = 'selected-item-single-item-active';
            }
        }
    }
    /**
     * A function that recives two params and generate a tooltip.
     * @param tooltipId This param represents the id of the tooltip.
     * @param target This param represents the container the tooltip points to.
     */
    generateTooltip(tooltipId, target) {
        // Select and remove the previous tooltip
        const tooltipContainer = document.getElementById(tooltipId);
        if (tooltipContainer)
            tooltipContainer.remove();
        // Select the container where the tooltip will be painted
        const targetContainer = document.getElementById(target);
        if (!targetContainer)
            return;
        const txtTarget = targetContainer.textContent;
        // Create the tooltip div and set id and target text
        const newTooltipContainer = document.createElement('div');
        newTooltipContainer.id = tooltipId;
        newTooltipContainer.innerHTML = txtTarget !== null && txtTarget !== void 0 ? txtTarget : '';
        // Add to target the tooltip container
        targetContainer.append(newTooltipContainer);
        // Check if target needed tooltip and set or remove class
        if (targetContainer && !this.checkOverflow(targetContainer)) {
            newTooltipContainer.classList.add('hide-tooltip');
        }
        else {
            newTooltipContainer.classList.remove('hide-tooltip');
        }
        // Check if exist target, tooltip and tooltip doesn't have hide-tooltip class
        if (targetContainer
            && newTooltipContainer
            && !(newTooltipContainer === null || newTooltipContainer === void 0 ? void 0 : newTooltipContainer.classList.contains('hide-tooltip'))) {
            const tooltip = new Tooltip(newTooltipContainer);
            tooltip.option('target', targetContainer);
            tooltip.option('showEvent', 'mouseenter');
            tooltip.option('hideEvent', 'mouseleave');
        }
    }
    /**
     * A function that recive one element and check if the text overflow or not.
     * @param el This param represents the element that will be checked if it overflows.
     * @returns Returns true if the element overflow and false if it doesn't.
     */
    checkOverflow(el) {
        const curOverflow = el.style.overflow;
        const element = el;
        const isOverflowing = el.clientWidth < el.scrollWidth;
        element.style.overflow = curOverflow;
        return isOverflowing;
    }
    /**
     * A function that setup and generate the tooltips for menu items.
     */
    setupTooltips() {
        const tooltipOptions = [];
        this.tooltipRandomId.forEach((id) => {
            tooltipOptions.push({
                tooltipId: `tooltip-menu-item-id-${id}`,
                target: `tooltip-menu-item-${id}`,
            });
        });
        tooltipOptions.forEach((t) => this.generateTooltip(t.tooltipId, t.target));
    }
    /**
    * Closes all accordions by setting their selected index to -1.
    */
    closeAccordions() {
        if (this.accordions.length > 0) {
            this.accordions.forEach((accordion) => {
                accordion.option('selectedIndex', -1);
            });
        }
    }
}
//# sourceMappingURL=dinapsis-navbar-sidebar-menu.js.map